export const reduxKey = '@@coreBadge';
